export const isSameUserId = (firstId, secondId) => {
  if (firstId?.toLowerCase() === secondId?.toLowerCase()) {
    return true
  }
  return false
}
